import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    width: '100%',
    padding: 0,
    zoom: '50%',
    fontWeight: 300,
    position: 'absolute',
    bottom: 0,
  },
  mobile: {
    marginTop: 0,
  },
  footer: {
    backgroundColor: theme.palette.neutralLight,
    padding: '50px 25px 50px 25px',

    marginTop: 50,
    selectors: {
      '& span': {
        fontSize: `${pxToRem(40)}`,
        fontWeight: 600,
        color: '#7d7e7d',
      },
      '& li': {
        padding: '10px 0',
        background: 'none',
        selectors: {
          a: {
            fontSize: `${pxToRem(26)}`,
            color: '#696565',
            transition: 'color 340ms ease-in-out',
            selectors: {
              '&:hover': {
                color: '#5a5454',
                textShadow: '.5px 0px 0px #c2bbbb',
              },
            },
          },
        },
      },
    },
  },
  navFooter: {
    backgroundColor: theme.palette.neutralLight,
    paddingBottom: '40px',
    selectors: {
      '& a': {
        fontSize: `${pxToRem(26)}`,
        color: '#5a5454',
        transition: 'color 3400ms ease-in-out',
        selectors: {
          '&:hover': {
            color: '#5a5454',
            textShadow: '.5px 0px 0px #c2bbbb',
          },
        },
      },
      alignSelf: 'center',
      padding: '20px 10px',
      borderColor: 'transparent',
      borderRadius: 0,
      color: 'white',
    },
  },
});
